import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-editor-toolbar-text-format",
  "use": "icon-sequence-editor-toolbar-text-format-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-sequence-editor-toolbar-text-format\">\n    <path d=\"M10.9927 9.95724L8.3266 1.95898H7.66008L4.99399 9.95724M5.66051 7.95768H10.3262M1.32812 13.2899H14.6586\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol